import styled from 'styled-components';

export const GinStepStepsContainer = styled.div`
  scroll-margin-top: ${({ theme }) => theme.appearance.appHeaderHeight + 24}px;
`;

export const GinStepsCustomClientState = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
